import { useQuery } from "@tanstack/react-query";
import { authService, SessionStatus } from "@/lib/api/services/auth";

export function useAuthSession() {
  return useQuery<SessionStatus>({
    queryKey: ["auth-session"],
    queryFn: () => authService.session(),
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always",
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
  });
}
